import { AccountConvertIcon } from './AccountConvertIcon';

/**
 * author: Austin Andrews
 * id A6964E10-1CF0-41FA-BDCA-A77C9C6F30AF
 * name account-convert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-convert.svg
 * tags
 * - Account / User 
 */
export const UserConvertIcon = AccountConvertIcon;
export default UserConvertIcon